import { api } from 'pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';
import type { dynamicObj } from 'src/pages/assets';
import { DOC2API_URL } from 'pages/APIs';

export default class InvoiceDashboardService extends AbstractApiService {
  public constructor({}) {
    super({});
  }

  public async getInvoiceDashboard(data: dynamicObj): Promise<any> {
    const querystring = this.encodeQueryData(data);
    return super.get(
      DOC2API_URL + '/supplier_invoice' + '?' + querystring,
    );
  }
  public async getOne(id: string): Promise<any> {
    return super.get(`${DOC2API_URL}/supplier_invoice/${id}`);
  }
  public async getInvoicePreviewPath(
    invoice_id: string,
    params: any,
  ): Promise<any> {
    const queryString = this.encodeQueryData(params);
    return super.get(
      `${DOC2API_URL}/supplier_invoice/get_invoice_preview/${invoice_id}?${queryString}`,
    );
  }
  public async getShareToken(invoice_id: string): Promise<any> {
    return super.get(
      `${DOC2API_URL}/supplier_invoice/share/${invoice_id}/token`,
    );
  }
  public async resetPreviewPath(): Promise<any> {
    return super.post(
      `${DOC2API_URL}/supplier_invoice/reset_supplier_invoice_preview_path`,
      new FormData(),
    );
  }
}
